import { FetchImportedInvoiceByIdResponseData } from '../query-api'
import { ImportedInvoice } from '../types/importedInvoice'
import { ImportedInvoicePaymentStatus } from '../types/importedInvoicePaymentStatus'
import { getImportedInvoiceIntegrationStatus } from './getImportedInvoiceIntegrationStatus'

export const getImportedInvoice = (invoice: FetchImportedInvoiceByIdResponseData): ImportedInvoice => ({
  approved: invoice.approved ?? null,
  extraction: {
    counterparty: invoice.counterparty ?? null,
    header: invoice.header ?? null,
    lines: invoice.lines ?? null,
    proposal: invoice.proposal ?? null,
  },
  fileId: invoice.fileId,
  fileName: invoice.filename ?? '',
  integrationRejectCode: invoice.cpaToolsIntegrationRejectCode ?? undefined,
  integrationStatus: getImportedInvoiceIntegrationStatus(invoice.cpaToolsIntegrationStatus),
  // TODO: placeholder until the by-id response carries a payment status: every approved row reads as
  // unpaid. https://linear.app/shine-co/issue/STR-396
  paymentStatus: invoice.approved ? ImportedInvoicePaymentStatus.Unpaid : undefined,
  status: invoice.status,
  uploadDate: invoice.uploadDate,
})
